import React from 'react';
import { useMessageSource } from 'react-message-source';
import './style.scss';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { useAutoFocus } from './hooks';

type ModalProps = {
  className?: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  show: boolean;
  title?: string;
  icon?: IconProp;
  noTitle?: boolean; // true -> do not show modal title and icon
  noClose?: boolean; // true -> do not show close button
  bgClose?: boolean; // true -> also closes when clicking outside the modal
  onClose: () => void;
};

const Modal = ({
  className,
  children,
  footer,
  show,
  title,
  icon,
  noTitle,
  noClose,
  bgClose = false, // 背景押下によるモーダルの非表示処理はデフォルト無効
  onClose,
}: ModalProps) => {
  const { getMessage } = useMessageSource();
  const className1 = 'modal-background' + (show ? ' show' : '');
  const className2 = 'modal-window' + (className ? ' ' + className : '');
  const { modalBodyRef } = useAutoFocus(show);

  return (
    <div
      className={className1}
      onClick={() => {
        if (!bgClose) return;
        onClose();
      }}
    >
      {show && (
        <div className={className2} onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>
              {!noTitle && (
                <>
                  <FontAwesomeIcon icon={icon ?? faCircleInfo} />
                  <span>{title ?? getMessage('project.modal.0001')}</span>
                </>
              )}
            </h2>
            {!noClose && (
              <div className="modal-close" onClick={onClose}>
                <FontAwesomeIcon icon={faXmark} />
              </div>
            )}
          </div>
          <div className="modal-body scrollbar" ref={modalBodyRef}>
            {children}
          </div>
          {footer && <div className="modal-footer">{footer}</div>}
        </div>
      )}
    </div>
  );
};

export default Modal;
